import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IActiveModal } from '../types.ts/model';
import { FormControl, FormGroup } from '@angular/forms';
import { PageModalController, PageModalService } from '../../page-modal.service';
import { LoginGuardService } from 'src/app/api/login-guard.service';

export const PaymentCreditAssignmentTypes = {
  REPLACE: "Replace",
  ADD:     "Add",
  REDUCE:  "Reduce",
}

export interface ICreditAssignmentData {
  testtakerId: string;
  currentValue: number;
  creditsCount: number;
  assignmentType: string;
  group_id?: string;
}

@Component({
  selector: 'assign-credit-modal',
  templateUrl: './assign-credit-modal.component.html',
  styleUrls: ['./assign-credit-modal.component.scss']
})
export class AssignCreditModalComponent implements OnInit {

  // @Input() currentModal: IActiveModal;
  // @Input() formGroup: FormGroup; 
  // @Input() availableCreditTypes: string[];
  @Input() userCreditInfo: { uid: string, creditCount: number};
  @Input() jurisInstitutionsList?: any[];
  @Input() modalType: string;
  // @Input() pageModal: PageModalController;

  @Output() assignCredit = new EventEmitter<ICreditAssignmentData>();

  pageModal: PageModalController;

  availableCreditTypes = [
    PaymentCreditAssignmentTypes.ADD,
    PaymentCreditAssignmentTypes.REDUCE,
  ];

  currentCreditFormGroup: FormGroup;

  constructor(
    private pageModalService: PageModalService,
    private loginGuard: LoginGuardService,
  ) { 
    this.initializeForm();
  }

  ngOnInit(): void {
    this.pageModal = this.pageModalService.defineNewPageModal();
  }

  initializeForm() {
    this.currentCreditFormGroup = new FormGroup({
      form_testtakerId: new FormControl({value: '', disabled: true}),
      from_currentCredit: new FormControl({value: 0, disabled: true}),
      from_assignmentType: new FormControl(),
      form_credits: new FormControl(),
      instit_list: new FormControl(),
    });
    
  }

  openModal() {
    const config: any = {};
    const controls = this.currentCreditFormGroup.controls;
    controls.form_testtakerId.setValue(this.userCreditInfo.uid);
    controls.from_currentCredit.setValue(this.userCreditInfo.creditCount);
    controls.from_assignmentType.setValue(PaymentCreditAssignmentTypes.ADD);
    if (this.jurisInstitutionsList) {
      controls.instit_list.setValue('');
    }
    this.pageModal.newModal({
      type: this.modalType,
      config,
      finish: config => {
        return this.handleModalSubmit();
        // const controls = this.currentCreditFormGroup.controls;
        // const payload = {
        //   testtakerId: controls.form_testtakerId.value,
        //   currentValue: controls.from_currentCredit.value,
        //   creditsCount: controls.form_credits.value,
        //   assignmentType: controls.from_assignmentType.value,
        //   // group_id: controls.instit_list.value
        // };
        // if (payload.creditsCount <= 0) {
        //   this.loginGuard.quickPopup("Value must be more than zero.");
        //   throw new Error();
        // }

        // if (payload.assignmentType == PaymentCreditAssignmentTypes.REDUCE) {
        //   if (payload.creditsCount > payload.currentValue) {
        //     this.loginGuard.quickPopup("Value should be less than current value");
        //     throw new Error();
        //   }
        // }

        // this.auth.apiCreate(this.routes.SUPPORT_CAND_CREDITS, payload)
        //   .then((res: ICreditHistory) => {
        //     if (res.message == 'success') {
        //       this.loginGuard.quickPopup("Updated Payment Credits Successfully.");
        //     }
        //     this.resetForm();
        //     this.reloadHistory(res);
        //   })
        //   .catch((error) => {
        //     this.loginGuard.quickPopup("Error updating Payment Credits.");
        //     console.error('Error updating Payment Credits', error);
        //   })
        //   .finally(() =>
        //     this.pageModal.closeModal()
        //   );
      }
    });
  }

  handleModalSubmit() {
    const controls = this.currentCreditFormGroup.controls;
    const payload: ICreditAssignmentData = {
      testtakerId: controls.form_testtakerId.value,
      currentValue: controls.from_currentCredit.value,
      creditsCount: controls.form_credits.value,
      assignmentType: controls.from_assignmentType.value,
    };
    if (this.jurisInstitutionsList) {
      payload.group_id = controls.instit_list.value;
    }
    if (payload.creditsCount <= 0) {
      this.loginGuard.quickPopup("Value must be more than zero.");
      throw new Error();
    }

    if (payload.assignmentType == PaymentCreditAssignmentTypes.REDUCE) {
      if (payload.creditsCount > payload.currentValue) {
        this.loginGuard.quickPopup("Value should be less than current value");
        throw new Error();
      }
    }

    this.assignCredit.emit(payload);
  }

  parseInstitName(instit: any) {
    return `${instit.name},  ${instit.city}`;
  }

  cModal() {
    return this.pageModal.getCurrentModal();
  }

  closeModal() {
    this.pageModal.closeModal();
  }

  resetForm() {
    this.currentCreditFormGroup.reset();
  }
}
